import React, { useEffect, useState } from 'react'
import ChatGPTModal from './ChatGPTModal'
import { isMac, verifyShortcut } from '../../../Components/action/utilities';
import { useSelector } from 'react-redux';

const AiAssistantModal = ({fullscreenButton = true}) => {
    const [chatGPTModal, setChatGPTModal] = useState(false);
    const settings = useSelector(state => state.settings.settings)

    useEffect(() => {
        document.removeEventListener('keydown', onPressCmd, false);
        document.addEventListener('keydown', onPressCmd, false);
    
        return () => {
          document.removeEventListener('keydown', onPressCmd, false);
        }
    }, [settings]);

    const onPressCmd = (e) => {
        if(typeof settings.keyboardShortcuts == 'undefined' || settings?.keyboardShortcuts?.openAssistant?.length > 0){
            const shortcut = settings?.keyboardShortcuts?.openAssistant?.length > 0 ? settings?.keyboardShortcuts?.openAssistant.join(' ') : (isMac ? 'Cmd' : 'Ctrl') + ' L';

            // Check if either meta (Cmd) or ctrl is pressed, and the 'L' key is pressed
            if(verifyShortcut(shortcut, e)){
                e.preventDefault();  // Prevent default browser behavior
                e.stopPropagation();  // Stop event propagation to prevent focusing the address bar
                setChatGPTModal(true);  // Open the popup/modal
            }
        }
    }

    return (
        chatGPTModal && <ChatGPTModal fullscreenButton={fullscreenButton} onHide={() => setChatGPTModal(false)} />
    )
}

export default AiAssistantModal